import styled from "styled-components";
const DefaultMaxScreenSize              = "575px";

const handleWidgetColorMode   = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
            case 'normal':
                return '#3c8dbc';
            case 'primary':
                return '#005792';
            case 'warning':
                return 'darkorange';
            case 'danger':
                return '#F05945';
            case 'error':
                //return 'red';
                return '#E02401';
            case "success":
                return 'darkgreen';
            case "subject":
                return '#3c8dbc';
            case 'information':
                return 'dimgrey';
            case 'online':
                return 'darkorange';
            case "inactive":
                return '#364E68';
            default:
                return '#005792';
        }
    } else {
        return '#005792';
    }
}
const handleButtonColorMode   = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
            case 'normal':
                return '#3c8dbc';
            case 'primary':
                return '#005792';
            case 'warning':
                return 'darkorange';
            case 'danger':
                return '#F05945';
            case 'error':
                return 'red';
            case "success":
                return 'darkgreen';
            case "subject":
                return '#3c8dbc';
            case 'information':
                return 'dimgrey';
            case 'online':
                return 'darkorange';
            case "inactive":
                return '#364E68';
            default:
                return '#005792';
        }
    } else {
        return '#005792';
    }
}

const handleButtonHoverColorMode   = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
            case 'normal':
                return '#3c8dbc';
            case 'primary':
                return '#1597E5';
            case 'warning':
                return 'darkorange';
            case 'danger':
                return '#F34573';
            case 'error':
                return '#F05454';
            case "success":
                return '#7ECA9C';
            case "subject":
                return '#3c8dbc';
            case 'information':
                return 'dimgrey';
            case 'online':
                return 'darkorange';
            case "inactive":
                return '#DFE2E2';
            default:
                return 'dimgrey';
        }
    } else {
        return 'dimgrey';
    }
}

export const WidgetConnContainer        = styled.div`
    border: solid 0.8px ${({ Mode }) => handleWidgetColorMode(Mode)};
    box-shadow: 0px 4px 20px -2px ${({ Mode }) => handleWidgetColorMode(Mode)};

    background-color: white;

    position: fixed;
    //bottom: 35px;
    bottom: 15px;
    right: 8px;

    min-height: 70px;
    min-width: 200px;
    max-width: 50%;

    border-radius: 5px;
    padding-bottom: 7px;   

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-inline-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
 
    z-index: 10;

    -webkit-animation: fadein 1s fadeout 1s; 
        -moz-animation: fadein 1s fadeout 1s; 
         -ms-animation: fadein 1s fadeout 1s; 
          -o-animation: fadein 1s fadeout 1s;
             animation: fadein 1s fadeout 1s;
    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        max-width: unset;
        width: 95%;

        transition: 0.3s ease-in-out;
    }
`;
export const WidgetConnHeader           = styled.div`
    width: 100%;
    background-color: ${({ Mode }) => handleWidgetColorMode(Mode)};
    color: #FFFFFF;

    top: 0px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;

    padding-top: 2px;
    padding-bottom: 2px;
`;
export const WidgetConnTitle            = styled.div`
    margin: auto;
    margin-left: 0.3em;
    font-size: 0.65em;
    text-transform: uppercase;
    font-weight: bold;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select:none;

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        font-size: 0.8em;
        transition: 0.3s ease-in-out;
    }
`;
export const WidgetConnController       = styled.div.attrs(({ IsBtnClose }) => ({
    title:  IsBtnClose? 'Click to close': undefined
  }))`
    cursor: pointer;
    &:hover {
        color: lightgrey;
    }
`;
export const WidgetConnBody             = styled.div`
    display: flex;
    flex-direction: column;
    background-color: transparent;

    padding-left: 5px;
    padding-right: 5px;
`;
export const WidgetConnInformation      = styled.div`
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`:'unset'
    )};
    color: ${({ Mode }) => handleWidgetColorMode(Mode)};
    display: flex;
    background-color: transparent;

    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        '11px':`${FontSize}`
    )}; 
    font-weight: ${({IsBold}) => (
        IsBold?
        'bold':'normal'
    )};
    text-transform: ${({IsUpperCase}) => (
        IsUpperCase?
        'uppercase':'normal'
    )}; 
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    
`;
export const WidgetConnMessage          = styled.div`
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`:'unset'
    )};
    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        '10px':`${FontSize}`
    )};   
    font-weight: ${({IsBold}) => (
        IsBold?
        'bold':'normal'
    )};
    text-transform: ${({IsUpperCase}) => (
        IsUpperCase?
        'uppercase':'normal'
    )};
    text-transform: ${({IsUpperCase}) => (
        IsUpperCase?
        'uppercase':'normal'
    )}; 
    display: flex;
    background-color: transparent;

    width: 100%;
    max-width: 100%;
    overflow: hidden;
`;

export const WidgetConnLabel            = styled.div`
    background-color: transparent;
    width: 100%;
    max-width: 100%;
    display: block;

    text-align: ${({IsCentered}) => (
        IsCentered?
        'center': 'left'
    )};

    width: max-content;
    height: auto;
    //max-width: 100%;
    //overflow: hidden;
    //white-space: pre;
    word-wrap: break-word;
    //text-overflow: ellipsis;
`;

export const RowButton                  = styled.div`
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`:'unset'
    )};
    display: flex;
    background-color: transparent;

    align-items: center;
    justify-content: center;
`;
export const Button                     = styled.button`
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    //justify-content: space-between;
    justify-content: center;

    border-radius: 4px;
    padding: ${({FitSize}) => (
        FitSize?
        '5px 9px':'6px 9px'
    )};
    opacity: unset;
    box-shadow: ${({Embossed, Mode}) => (
        Embossed?
        '3px 3px ' + handleWidgetColorMode(Mode) :'none'
    )};
    border: none;
    min-width: ${({MinWidth, FitSize}) => (
        FitSize?
        'fit-content'
        :typeof MinWidth === 'string' && MinWidth.trim() !== ''?
        MinWidth:'90px'
    )};
    width: ${({Width, FitSize}) => (
        FitSize?
        'fit-content'
        :typeof Width === 'number' && Width > 0?
        `${Width}px`:'max-content'
    )};
    height: ${({Height}) => (
        typeof Height === 'number' && Height > 0?
        `${Height}px`:'max-content'
    )};
    background-color: ${({ Mode }) => handleButtonColorMode(Mode)};
    color: #FFFFFF;

    &:hover {
        background-color: ${({ Mode }) => handleButtonHoverColorMode(Mode)};
    }

    &:focus {
        background-color: ${({ Mode }) => handleButtonHoverColorMode(Mode)};
    }
`;
export const ButtonText                 = styled.div`
    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        '9px':`${FontSize}`
    )};

    text-transform: ${({IsNotUpperCase}) => (
        IsNotUpperCase?
        'normal':'uppercase'
    )};
    font-weight: ${({IsNotBold}) => (
        IsNotBold?
        'normal':'bold'
    )};   
`;

export const ControllerBtnIconLarge     = styled.div`
    display: none;
    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        display: flex;
        transition: 0.3s ease-in-out;
    }        
`;
export const ControllerBtnIcon          = styled.div`
    display: flex;
    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        display: none;
        transition: 0.3s ease-in-out;
    } 
`;